import React, { useEffect, useRef, useState } from "react";
import "./Appointments.scss";
import { Modal } from "react-bootstrap";
import moment from "moment";
import { Link } from "react-router-dom";
import clearStorage from "../DoctorVideo/PatientInfoData";
import IconButton from "@material-ui/core/IconButton";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import VideoIcon from "../../assets/video_call_black_24dp.svg";
import MarkNoShowIcon from "../../assets/Mark-No-Show-Icon.svg";
import UserDetailIcon from "../../assets/person-24px.svg";
import CancelIcon from "../../assets/cancel-px.svg";
import RescheduleIcon from "../../assets/reschedule.svg";
import ViewDocumentIcon from "../../assets/view-documents.svg";
import ViewPrescriptionIcon from "../../assets/view-prescription.svg";
import EditPrescriptionIcon from "../../assets/edit-prescription.svg";

import NotAvailble from "../../assets/not-available.svg";
import { makeStyles } from "@material-ui/core/styles";
import getAppointmentOptions from "./AppointmentOptions";
import CallModal from "../DoctorDashboard/CallModal";
import ShareReceiptModal from "./ShareReceiptModal";
import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import shareIcon from "../../assets/pem_share_icon.svg";
import PEMShareContentPopUp from "../PEM";
import Popup from "../PEM/common/Popup";
import DocumentContainer from "../UI Component/DocumentViewer/DocumentCotainer";
import Loader from "../UI Component/Loader/Loader";
import swal from "sweetalert";
import useWindowSize from "../../Hooks/useWindowSize";
import {
  dateFormatter,
  timeFormatter,
} from "../../Util/Helper/dateManipulation";
import { CONSULTATIONTYPE } from "../DashboardAppointmentsView/Constant";
import { CHECK_NO_SHOW_STATUS_API } from "../DashboardAppointmentsView/DashboardAppointmentsViewApiHandler/APIConstants";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import { c2cPostApiHandler } from "../../Util/c2cApiHandler";

const useStyles = makeStyles((theme) => ({
  padding: {
    padding: 2,
  },
  disableWithPadding: {
    cursor: "not-allowed !important",
    opacity: 0.65,
    padding: 2,
  },
}));
export default function AppointmentTableRow({
  appointmentData,
  index,
  renderAppointmentType,
  viewAppointment,
  renderConsultationType,
  handleViewDocumentClick,
  editPrescriptionAction,
  rescheduleAppointmentAction,
  cancelAppointmentAction,
  raiseInvoiceAction,
  markNoShowAction,
  handleJoinCallClick,
  currentPage,
}) {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [timeExceededTooltip, setTimeExceededTooltip] = useState("");
  const [showVideoIcon, setShowVideoIcon] = useState(false);
  const [showPreviousNext, setShowPreviousNext] = useState(false);
  const [showCallPatientModal, setShowCallPatientModal] = useState(false);
  const [showCallPatientText, setShowCallPatientText] = useState(false);
  const [showReceiptModal, setshowReceiptModal] = useState(false);
  const [showPEMShare, setshowPEMShare] = useState(false);
  const [selectedPatientId, setselectedPatientId] = useState("");
  const [showPopUp, setShowPopUp] = useState(false);
  const [documentShow, setDocumentShow] = useState(false);
  const [fileDetails, setFileDetails] = useState({
    fileURL: "",
    fileName: "Invoice for Your Connect2Clinic appointment",
    fileType: ".pdf",
  });
  const [loader, setloader] = useState(false);
  const size = useWindowSize();
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState();

  useEffect(() => {
    let time = moment(
      appointmentData.appointment_date +
        "T" +
        appointmentData.appointment_start_time
    )
      .add(12, "hours")
      .format("MMM DD, YYYY hh:mm A");
    let tooltip = `The Appointment link will be active till ${time}. It will automatically get cancelled and refunded in case consultation does not happen.`;
    setTimeExceededTooltip(tooltip);
  }, [appointmentData]);

  useEffect(() => {
    if (appointmentData !== null && appointmentData.appointment_id !== "") {
      const current = moment();
      const dtAppointment = moment(
        appointmentData.appointment_date +
          "T" +
          appointmentData.appointment_start_time
      );

      let difference = Math.abs(current.diff(dtAppointment, "minutes"));

      if (
        difference < 720 &&
        appointmentData?.appointment_status !== "completed" &&
        !appointmentData?.appointment_status
          ?.toLowerCase()
          .includes("cancelled") &&
        appointmentData.appointment_type === "online"
      ) {
        setShowVideoIcon(true);
      } else {
        setShowVideoIcon(false);
      }
      if (
        difference < -720 ||
        (difference < 720 && appointmentData.appointment_type === "online") ||
        appointmentData.appointment_type === "in-clinic"
      ) {
        setShowCallPatientText(true);
      } else {
        setShowCallPatientText(false);
      }
    }
  }, [appointmentData]);

  const options = [
    {
      icon: "fa-phone",
      label: "Call Patient",
      clickHandler: () => {
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(
            appointmentData,
            setShowCallPatientModal,
            true
          );
        } else {
          setShowCallPatientModal(true);
        }
        setAnchorEl(null);
      },
    },
    {
      icon: "fa-file-text",
      label: "View Documents",
      clickHandler: () => {
        handleViewDocumentClick(appointmentData);
        setAnchorEl(null);
      },
    },
    {
      icon: `${UserDetailIcon}`,
      label: "View Details",
      clickHandler: () => {
        viewAppointment(
          appointmentData.appointment_id,
          appointmentData.appointment_status
        );
        setAnchorEl(null);
      },
    },
    {
      icon: `${RescheduleIcon}`,
      label: "Reschedule",
      clickHandler: () => {
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(
            appointmentData,
            rescheduleAppointmentAction,
            appointmentData
          );
        } else {
          rescheduleAppointmentAction(appointmentData);
        }
        setAnchorEl(null);
      },
    },
    {
      icon: `${CancelIcon}`,
      label: "Cancel",
      clickHandler: () => {
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(
            appointmentData,
            cancelAppointmentAction,
            appointmentData
          );
        } else {
          cancelAppointmentAction(appointmentData);
        }
        setAnchorEl(null);
      },
    },
    {
      icon: `${CancelIcon}`,
      label: "View Receipt",
      clickHandler: () => {
        viewReceipt();
        setAnchorEl(null);
      },
    },
    {
      icon: `${CancelIcon}`,
      label: "Share Receipt",
      clickHandler: () => {
        shareReceipt();
        setAnchorEl(null);
      },
    },
  ];

  // in-clinic menu options
  const inClinicOptions = [
    {
      icon: "fa-file",
      label: "Mark Check In",
      clickHandler: () => {
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(
            appointmentData,
            raiseInvoiceAction,
            appointmentData
          );
        } else {
          raiseInvoiceAction(appointmentData);
        }
        setAnchorEl(null);
      },
    },
    {
      icon: `${MarkNoShowIcon}`,
      label: "Mark No Show",
      clickHandler: () => {
        if (appointmentData?.appointment_type === CONSULTATIONTYPE.INCLINIC) {
          checkAppointmentStatusApi(
            appointmentData,
            markNoShowAction,
            appointmentData
          );
        } else {
          markNoShowAction(appointmentData);
        }
        setAnchorEl(null);
      },
    },
  ];

  // Add menu options only if in-clinic appointment
  if (
    appointmentData.appointment_type === "in-clinic" &&
    appointmentData.appointment_status !== "completed"
  ) {
    options.splice(1, 0, ...inClinicOptions);
  }

  const open = Boolean(anchorEl);

  // API Calls ==>

  const checkAppointmentStatusApi = (appnt, func, param) => {
    let data = {
      appointment_id: appnt.appointment_id,
    };
    let statusData = c2cPostApiHandler(CHECK_NO_SHOW_STATUS_API, data);
    statusData.then(([res, error]) => {
      if (!error) {
        if (res && data.appointment_id === res.data?.data?.appointment_id) {
          if (res.data?.data?.no_show === "False") {
            param ? func(param) : func();
          } else {
            setShowMessage(true);
            setMessage("This appointment is marked as No Show");
            setTimeout(() => {
              setShowMessage(false);
              window.location.reload();
            }, 1500);
          }
        }
      }
    });
  };

  // <===

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };
  let is_staff = localStorage.getItem("user_type");
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  // Timer logic =>
  let countDownTime = "";
  let interval = useRef();
  const [timerHours, setTimerHours] = useState("00");
  const [timerMinutes, setTimerMinutes] = useState("00");
  const [timerSeconds, setTimerSeconds] = useState("00");

  let startTimer = (endTimeValue) => {
    // const endTime = moment(endTimeValue);

    const startTime = endTimeValue;
    const durationInMinutes = "48";
    const initalDateTime = moment(startTime, "YYYY-MM-DD HH:mm:ss")
      .add(durationInMinutes, "hours")
      .format("YYYY-MM-DD HH:mm:ss");

    const finalDateTime = moment(initalDateTime);

    interval = setInterval(() => {
      let distance = finalDateTime.diff(moment());
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 48)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      if (distance < 0) {
        clearInterval(interval.current);
      } else {
        setTimerHours(hours);
        setTimerMinutes(minutes);
        setTimerSeconds(seconds);
      }
    }, 1000);
  };
  const shareReceipt = () => {
    let payload = {
      doctor_id: appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : userId,
      user_type: localStorage.getItem("user_type"),
      appointment_id: appointmentData.appointment_id,
    };
    if (localStorage.getItem("user_type") === "staff") {
      payload = {
        ...payload,
        staff_id: staffId,
      };
    }
    afterLoginApiAxios
      .post("api/v1/doctor/share-receipt", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      })
      .then((response) => {
        if (response.data.statusCode === 200) {
          setshowReceiptModal(true);
          setTimeout(function () {
            setshowReceiptModal(false);
            window.location.reload();
          }, 2000);
        }
      })
      .catch((err) => C2CConsole.log(err));
  };

  const viewReceipt = () => {
    setloader(true);
    let payload = {
      doctor_id: appointmentData?.doctor_id
        ? appointmentData?.doctor_id
        : userId,
      user_type: localStorage.getItem("user_type"),
      appointment_id: appointmentData.appointment_id,
      is_shared: "False",
    };
    if (localStorage.getItem("user_type") === "staff") {
      payload = {
        ...payload,
        staff_id: staffId,
      };
    }
    afterLoginApiAxios
      .post("api/v1/doctor/share-receipt", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("id_token"),
        },
      })
      .then((response) => {
        if (response?.data?.statusCode === 200) {
          setloader(false);
          setFileDetails((prev) => ({
            ...prev,
            fileURL: response?.data?.invoice_link,
          }));
          // setshowReceiptModal(true);
          // setTimeout(function () {
          //   setshowReceiptModal(false);
          // }, 2000);
          if (response?.data?.invoice_link !== "") {
            setDocumentShow(true);
          } else {
            swal({
              title: "Unable to generate receipt.",
              text: "Please try again",
              icon: "error",
              button: "Okay",
            });
            setDocumentShow(false);
          }
        } else {
          swal({
            title: "Unable to generate receipt.",
            text: "Please try again",
            icon: "error",
            button: "Okay",
          });
          setloader(false);
          setDocumentShow(false);
        }
      })
      .catch((err) => {
        setloader(false);
        setDocumentShow(false);
        C2CConsole.log(err);
      });
  };

  const sharePEMClick = (id) => {
    setselectedPatientId(id);
    setshowPEMShare(true);
  };

  const mob_options = getAppointmentOptions({
    appointmentData,
    markNoShowAction,
    rescheduleAppointmentAction,
    raiseInvoiceAction,
    handleViewDocumentClick,
    setAnchorEl,
    showVideoIcon,
    handleJoinCallClick,
    viewAppointment,
    cancelAppointmentAction,
    startTimer,
    editPrescriptionAction,
    setShowCallPatientModal,
    timerHours,
    timerMinutes,
    timerSeconds,
    shareReceipt,
    viewReceipt,
    sharePEMClick,
  });
  // navigation logic =>

  const pemCloseBtnCallback = (closeBtnState = false) => {
    setshowPEMShare(false);
    if (!closeBtnState) {
      setShowPopUp(true);
    }
  };

  const viewPrescription = (appointment) => {
    if (
      appointment.prescription_notification_sent === "True" &&
      appointment.manual_rx_notification_sent === "True"
    ) {
      return (
        <IconButton
          className={classes.padding}
          aria-label="View Prescription"
          data-tooltip="View Prescription"
          data-tooltip-conf="bottom"
        >
          <Link
            to={{
              pathname:
                "/doctor/account/appointmenthistory/prescription/" +
                appointment.appointment_id,
              state: {
                pageNumber: currentPage,
              },
            }}
          >
            <img
              src={ViewPrescriptionIcon}
              alt="View Prescription"
              style={{ width: 18 }}
            />
          </Link>
        </IconButton>
      );
    }
    return null;
  };

  const editPrescription = (appointment) => {
    // if (appointment?.prescription_notification_sent) {
    //   if (appointment?.prescription_notification_sent === "False" || appointment.manual_rx_notification_sent==="False") {
    const endTime = moment(
      appointment?.appointment_end_date_time.split("+")[0]
    ).add(48, "hours");
    const editButtonStatus = moment().isAfter(endTime); // true
    let is_allow = localStorage.getItem("edit_prescriptions_allow");
    if (
      editButtonStatus ||
      (timerHours === 0 && timerMinutes === 0 && timerSeconds === 0)
    ) {
      // return null;
      if (
        appointment.prescription_notification_sent === "True" ||
        appointment.manual_rx_notification_sent === "True"
      ) {
        return (
          <IconButton
            className={classes.padding}
            aria-label="View Prescription"
            data-tooltip="View Prescription"
            data-tooltip-conf="bottom"
          >
            <Link
              to={{
                pathname:
                  "/doctor/account/appointmenthistory/prescription/" +
                  appointment.appointment_id,
                state: {
                  pageNumber: currentPage,
                },
              }}
            >
              <img
                src={ViewPrescriptionIcon}
                alt="View Prescription"
                style={{ width: 18 }}
              />
            </Link>
          </IconButton>
        );
      }
    } else {
      startTimer(appointment?.appointment_end_date_time);
      clearStorage.clearPatientData();
      return (
        <>
          <IconButton
            className={classes.padding}
            aria-label="Edit Prescription"
            onClick={() => editPrescriptionAction(appointment)}
            data-tooltip="Edit Prescription"
            data-tooltip-conf="bottom"
            disabled={is_staff === "doctor" ? false : !is_allow}
          >
            <img
              src={EditPrescriptionIcon}
              alt="Edit Prescription"
              style={{ width: 18 }}
            />
          </IconButton>
        </>
      );
    }
  };

  function editReceipt(appointment, type) {
    let displayEditReceipt = false;
    if (
      appointment?.mark_check_in_time &&
      appointment?.receipt_finalized !== "True"
    ) {
      let twelveHr = moment(appointment?.mark_check_in_time)
        .add(12, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
      const finalDateTime = moment(twelveHr);
      let distance = finalDateTime.diff(moment());
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 48)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);
      displayEditReceipt = hours > 0 || minutes > 0 || seconds > 0;
    }

    return (
      <>
        {displayEditReceipt ? (
          <div className={type === "mobile" ? "edit-receipt-mobile" : ""}>
            <IconButton
              className={classes.padding}
              aria-label="Edit Receipt"
              onClick={() => {
                getEditReceipt(appointmentData);
              }}
              data-tooltip="Edit Receipt"
              data-tooltip-conf="bottom"
            >
              <img
                src={require("../../assets/edit_blue.svg")}
                alt="Edit Receipt"
              />
            </IconButton>
            {type === "mobile" ? (
              <div style={{ fontSize: "0.6rem", marginTop: "6px" }}>
                Edit Receipt
              </div>
            ) : null}
          </div>
        ) : null}
      </>
    );
  }

  function getEditReceipt(appointmentData) {
    appointmentData.edit_receipt = true;
    raiseInvoiceAction(appointmentData);
  }

  function getActionSheet(appointment) {
    return (
      <>
        <div style={{ display: "flex" }}>
          <IconButton
            className={classes.padding}
            aria-label="View Documents"
            onClick={() =>
              appointment.has_document === "True"
                ? handleViewDocumentClick(appointment)
                : ""
            }
            data-tooltip={
              appointment.has_document === "True" ? "View Documents" : null
            }
            data-tooltip-conf="bottom"
          >
            {appointment?.has_document === "True" &&
            appointment?.appointment_status != "No show" ? (
              <img
                src={ViewDocumentIcon}
                alt="View Document"
                style={{ width: 18 }}
              />
            ) : (
              <img src={NotAvailble} alt="No Document" style={{ width: 18 }} />
            )}
          </IconButton>
          {appointment.appointment_status === "completed" &&
          localStorage.getItem("user_type") === "doctor" ? (
            <IconButton
              className={classes.padding}
              aria-label="View Details"
              onClick={() => {
                sharePEMClick(appointment.patient_id);
              }}
              data-tooltip="Share Patient Education Content"
              data-tooltip-conf="bottom"
            >
              <img src={shareIcon} alt="Share Patient Education Content" />
            </IconButton>
          ) : (
            <IconButton
              className={classes.padding}
              aria-label="View Details"
              // onClick={handleJoinCallClick}
              onClick={() => {
                viewAppointment(
                  appointment.appointment_id,
                  appointment.appointment_status
                );
                // navigate to viewAppointment
              }}
              data-tooltip="View Details"
              data-tooltip-conf="bottom"
            >
              <img src={UserDetailIcon} alt="View Details" />
            </IconButton>
          )}
          {appointment?.appointment_status != "No show" &&
            appointment?.appointment_status === "completed" &&
            editPrescription(appointment)}
          {editReceipt(appointment)}
          {appointment?.appointment_status != "No show" &&
          appointment?.appointment_status !== "completed" &&
          !appointmentData?.appointment_status
            ?.toLowerCase()
            .includes("cancelled") &&
          (!appointmentData?.appointment_status?.includes("reschedule") ||
            appointmentData?.appointment_status?.includes("upcoming")) &&
          appointmentData?.appointment_type === "online" &&
          showVideoIcon ? (
            <>
              {localStorage.getItem("user_type") != "staff" ? (
                <IconButton
                  className={classes.padding}
                  aria-label="join-call"
                  onClick={() => handleJoinCallClick(appointment)}
                  data-tooltip="Join Call"
                  data-tooltip-conf="bottom"
                >
                  <img
                    src={VideoIcon}
                    alt="Start Video"
                    style={{ width: 18 }}
                  />
                </IconButton>
              ) : (
                <IconButton
                  className={classes.disableWithPadding}
                  aria-label="join-call"
                  data-tooltip="Join Call"
                  data-tooltip-conf="bottom"
                >
                  <img
                    src={VideoIcon}
                    alt="Start Video"
                    style={{ width: 18 }}
                  />
                </IconButton>
              )}
            </>
          ) : (
            ""
          )}
        </div>
        <div>
          {appointment?.appointment_status != "No show" &&
            !appointmentData?.appointment_status
              ?.toLowerCase()
              .includes("cancelled") && (
              <IconButton
                className={classes.padding}
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleMenuClick}
              >
                <MoreHorizIcon />
              </IconButton>
            )}
        </div>
        {appointment?.appointment_status !== "completed" ? (
          <Menu
            id="long-menu"
            open={open}
            anchorEl={anchorEl}
            keepMounted
            onClose={handleMenuClose}
          >
            {options.map((option, index) =>
              showCallPatientText
                ? option?.label !== "View Documents" &&
                  option?.label !== "View Details" &&
                  option?.label !== "View Receipt" &&
                  option?.label !== "Share Receipt" && (
                    <MenuItem key={index}>
                      <div
                        onClick={() => {
                          option.clickHandler(appointment);
                        }}
                      >
                        <span className="pl-2">{option.label}</span>
                      </div>
                    </MenuItem>
                  )
                : option?.label !== "Call Patient" &&
                  option?.label !== "View Documents" &&
                  option?.label !== "View Details" && (
                    <MenuItem key={index}>
                      <div
                        onClick={() => {
                          option.clickHandler(appointment);
                        }}
                      >
                        <span className="pl-2">{option.label}</span>
                      </div>
                    </MenuItem>
                  )
            )}
          </Menu>
        ) : (
          <Menu
            id="long-menu"
            open={open}
            anchorEl={anchorEl}
            keepMounted
            onClose={handleMenuClose}
          >
            {options.map(
              (option, index) =>
                option?.label !== "Call Patient" &&
                option?.label !== "Reschedule" &&
                option?.label !== "Cancel" && (
                  <MenuItem key={index}>
                    <div
                      onClick={() => {
                        option.clickHandler(appointment);
                      }}
                    >
                      <span className="pl-2">{option.label}</span>
                    </div>
                  </MenuItem>
                )
            )}
          </Menu>
        )}
        <CallModal
          openView={showCallPatientModal}
          closeView={() => {
            setShowCallPatientModal(false);
          }}
          modalCloseView={() => {
            setShowCallPatientModal(false);
          }}
          appointment_id={appointmentData.appointment_id}
          patientName={appointmentData.patient_name}
        />
      </>
    );
  }

  function getExpireDisplay(appointment) {
    const endTime = moment(
      appointment?.appointment_end_date_time.split("+")[0]
    ).add(48, "hours");
    const editButtonStatus = moment().isAfter(endTime); // true
    let expire;
    if (
      editButtonStatus ||
      (timerHours === 0 && timerMinutes === 0 && timerSeconds === 0)
    ) {
      expire = null;
    } else {
      expire = (
        <small
          className="cursor-pointer textLink text-center"
          style={{
            color: "#DA1346",
            fontSize: 10,
            alignItems: "center",
            display: "flex",
          }}
        >
          Expires in &nbsp;
          <span>
            {timerHours}:{timerMinutes < 10 ? `0${timerMinutes}` : timerMinutes}
            :{timerSeconds < 10 ? `0${timerSeconds}` : timerSeconds}
          </span>
        </small>
      );
    }

    return (
      <>
        {appointment?.appointment_status != "No show" &&
          appointment?.appointment_status === "completed" &&
          expire}
      </>
    );
  }

  const renderAppointment = (appointmentData) => {
    return (
      <>
        <p className="m-0 text-label">{appointmentData?.appointment_status}</p>
        {appointmentData?.staff_name != "" && (
          <p className="m-0 text-label">
            {appointmentData?.staff_name != "" &&
            (appointmentData?.appointment_status?.toLowerCase() ==
              "reschedule by staff" ||
              appointmentData?.appointment_status?.toLowerCase() ==
                "cancelled by staff")
              ? appointmentData?.staff_name
              : null}
          </p>
        )}
        {appointmentData?.appointment_status &&
          appointmentData?.appointment_status.toLowerCase() === "completed" && (
            <p className="m-0">
              <small>
                {appointmentData?.appointment_type === "in-clinic"
                  ? appointmentData?.appointment_end_date_time != ""
                    ? "On " +
                      moment
                        .parseZone(
                          appointmentData.appointment_end_date_time.split(
                            " "
                          )[0]
                        )
                        .format("MMM DD, YYYY") +
                      " " +
                      moment(
                        appointmentData?.appointment_end_date_time.split("+")[0]
                      ).format("hh:mm A")
                    : " "
                  : appointmentData?.appointment_end_time != ""
                  ? "On " +
                    dateFormatter(appointmentData.appointment_date) +
                    " " +
                    moment(
                      appointmentData.appointment_end_time,
                      "hh:mm:ss"
                    ).format("hh:mm A")
                  : " "}
              </small>
            </p>
          )}
        {appointmentData?.appointment_status &&
          appointmentData?.appointment_status
            ?.toLowerCase()
            .includes("reschedule") && (
            <p className="m-0">
              <small>
                {appointmentData?.reschedule_time != ""
                  ? "On " +
                    dateFormatter(appointmentData.reschedule_time) +
                    " " +
                    timeFormatter(appointmentData?.reschedule_time)
                  : " "}
              </small>
            </p>
          )}
        {appointmentData?.appointment_status &&
          appointmentData?.appointment_status
            ?.toLowerCase()
            .includes("cancelled") && (
            <p className="m-0">
              <small>
                {appointmentData?.cancel_time != ""
                  ? "On " +
                    dateFormatter(appointmentData?.cancel_time) +
                    " " +
                    timeFormatter(appointmentData?.cancel_time)
                  : " "}
              </small>
            </p>
          )}
        {appointmentData?.appointment_status &&
          appointmentData?.appointment_status
            ?.toLowerCase()
            .includes("no show") && (
            <p className="m-0">
              <small>
                {appointmentData?.no_show_time != ""
                  ? "On " +
                    dateFormatter(appointmentData?.no_show_time) +
                    " " +
                    timeFormatter(appointmentData?.no_show_time)
                  : " "}
              </small>
            </p>
          )}
      </>
    );
  };

  const renderDocument = (width) => {
    if (documentShow) {
      return (
        <DocumentContainer
          cancelHandler={() => closeNotification()}
          url={fileDetails.fileURL}
          fileName={fileDetails.fileName}
          fileType={fileDetails.fileType}
          width={width || ""}
        />
      );
    }
  };
  const closeNotification = () => {
    setDocumentShow(false);
    setFileDetails({
      fileName: "",
      fileURL: "",
      fileType: "",
    });
  };
  return (
    <>
      {loader && <Loader />}
      <div>
        {showPEMShare ? (
          <PEMShareContentPopUp
            patientId={selectedPatientId}
            appointment_id={appointmentData?.appointment_id}
            isERx={appointmentData.prescription_notification_sent}
            pemCloseBtnCallback={pemCloseBtnCallback}
          />
        ) : (
          ""
        )}

        <div className="d-sm-none d-lg-flex d-none flex-column cont-width-main-body-appointment-history patient-row-individual-row border shadow-sm my-2 mx-0 rounded-sm">
          <div
            className={`transaction-table-data-body  ${
              size.width > 768 && "align-items-center"
            }`}
            key={appointmentData?.appointment_number}
          >
            <div className="created_at">
              <p className="m-0">
                {moment(appointmentData.appointment_date).format(
                  "MMM DD, YYYY"
                )}
              </p>
              <p className="m-0">
                <small>
                  {moment(
                    appointmentData?.appointment_start_time,
                    "hh:mm:ssZ"
                  ).format("hh:mm A")}
                </small>
              </p>
              {moment() >
                moment(
                  `${appointmentData?.appointment_date} ${appointmentData?.appointment_end_time}`
                ) &&
              appointmentData?.appointment_type === "online" &&
              (appointmentData.appointment_status.includes("reschedule") ||
                appointmentData.appointment_status.toLowerCase() ==
                  "upcoming") ? (
                <p className="m-0 text-danger">
                  <small
                    data-tooltip={timeExceededTooltip}
                    data-tooltip-conf="multiline bottom"
                  >
                    Time exceeded &nbsp;
                    <i className="fa fa-info-circle"></i>
                  </small>
                </p>
              ) : (
                ""
              )}
              {moment() >
                moment(
                  `${appointmentData.appointment_date} ${appointmentData.appointment_start_time}`
                ) &&
              appointmentData.appointment_type === "in-clinic" &&
              (appointmentData.appointment_status.includes("reschedule") ||
                appointmentData.appointment_status.toLowerCase() ==
                  "upcoming") ? (
                <p className="m-0 text-danger">
                  <small
                    data-tooltip="Please raise an invoice if the consultation has happened successfully or mark no show"
                    data-tooltip-conf="multiline bottom"
                  >
                    Time exceeded &nbsp;
                    <i className="fa fa-info-circle"></i>
                  </small>
                </p>
              ) : (
                ""
              )}
            </div>
            <div className="mark_checkin_date_time text-label">
              {appointmentData.mark_check_in_time ? (
                <>
                  <p className="m-0 text-label ">
                    {moment(appointmentData.mark_check_in_time).format(
                      "MMM DD, YYYY"
                    )}
                  </p>
                  <p className="m-0 text-label ">
                    <small>
                      {moment(appointmentData?.mark_check_in_time).format(
                        "hh:mm A"
                      )}
                    </small>
                  </p>
                </>
              ) : (
                "-"
              )}
            </div>
            <div className="mark_checkin_by text-label">
              {appointmentData.mark_check_in_time ? (
                <>
                  <p className="m-0 text-label ">
                    {appointmentData?.mark_check_in_by}
                  </p>
                  <p className="m-0 text-label ">
                    <small>{appointmentData?.mark_check_in_by_name}</small>
                  </p>
                </>
              ) : (
                "-"
              )}
            </div>
            {is_staff === "staff" ? (
              <div className="doctor_name text-label">
                {appointmentData?.doctor_name}
              </div>
            ) : (
              ""
            )}
            <div className="patient_phone_no">
              {appointmentData?.patient_phone_no}
            </div>
            <div className="appointment_status text-left">
              <p className="m-0 text-label ">
                {renderAppointmentType(appointmentData?.appointment_type)}
              </p>
              <p className="m-0 text-label ">
                <small>
                  {renderConsultationType(
                    appointmentData?.appointment_type,
                    appointmentData?.consultation_type,
                    appointmentData?.procedure_name,
                    appointmentData?.all_procedure_name,
                    appointmentData?.appointment_id,
                    appointmentData?.appointment_status,
                    appointmentData?.payment_method
                  )}
                </small>
              </p>
            </div>
            <div className={`status`}>{renderAppointment(appointmentData)}</div>
          </div>
          <div className="action-rows p-2 d-flex justify-content-between align-items-center">
            <div>
              <p className="pl-3 m-0">
                Patient Details &nbsp;&nbsp;{" "}
                <b>{appointmentData?.patient_name}</b> |{" "}
                <b>{appointmentData?.patient_phone_no}</b>
              </p>
            </div>

            <div>
              <div className="action_type pr-3 d-flex align-items-center action-button  justify-content-end">
                {getActionSheet(appointmentData)}
              </div>
              <div className="d-flex justify-content-end pr-3">
                {getExpireDisplay(appointmentData)}
              </div>
            </div>
          </div>
        </div>

        {/* Mobile section */}
        <div
          className="row appointment-row py-2 px-2 mb-2 shadow-sm rounded-sm d-xs d-sm d-md d-lg-none d-xl-none"
          key={appointmentData.appointment_start_time}
        >
          <div className="col-12">
            <div className="row">
              <div className="col-6">
                <p className="header m-0 mb-1">Date &amp; Time</p>
                <p className="m-0">
                  {moment(appointmentData.appointment_date).format(
                    "MMM DD, YYYY"
                  )}
                </p>
                <p className="m-0">
                  <small>
                    {moment(
                      appointmentData.appointment_start_time,
                      "hh:mm:ssZ"
                    ).format("hh:mm A")}
                  </small>
                </p>
                {moment() >
                  moment(
                    `${appointmentData.appointment_date} ${appointmentData.appointment_end_time}`
                  ) &&
                appointmentData.appointment_type === "online" &&
                (!appointmentData.appointment_status.includes("reschedule") ||
                  appointmentData.appointment_status.toLowerCase() ==
                    "upcoming") ? (
                  <p className="m-0 text-danger">
                    <small
                      data-tooltip={timeExceededTooltip}
                      data-tooltip-conf="multiline bottom"
                    >
                      Time exceeded &nbsp;
                      <i className="fa fa-info-circle"></i>
                    </small>
                  </p>
                ) : (
                  ""
                )}
                {moment() >
                  moment(
                    `${appointmentData.appointment_date} ${appointmentData.appointment_start_time}`
                  ) &&
                appointmentData.appointment_type === "in-clinic" &&
                (appointmentData.appointment_status.includes("reschedule") ||
                  appointmentData.appointment_status.toLowerCase() ==
                    "upcoming") ? (
                  <p className="m-0 text-danger">
                    <small
                      data-tooltip="Please raise an invoice if the consultation has happened successfully or mark no show"
                      data-tooltip-conf="multiline bottom"
                    >
                      Time exceeded &nbsp;
                      <i className="fa fa-info-circle"></i>
                    </small>
                  </p>
                ) : (
                  ""
                )}
              </div>
              <div className="col-6">
                <p className="header m-0 mb-1">Patient Name</p>
                <p className="m-0">{appointmentData.patient_name}</p>
              </div>
              <div className="col-6"></div>
            </div>
            <div className="row mt-2">
              {is_staff === "staff" ? (
                <div className="col-6">
                  <p className="header m-0 mb-1">Doctor Name</p>
                  <p className="m-0">{appointmentData.doctor_name}</p>
                </div>
              ) : (
                ""
              )}
              <div className="col-6">
                <p className="header m-0 mb-1">Mobile Number</p>
                <p className="m-0">{appointmentData.patient_phone_no}</p>
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-6">
                <p className="header m-0 mb-1">Appointment Status</p>
                {renderAppointment(appointmentData)}
              </div>
              <div className="col-6">
                <p className="header m-0 mb-1">Consultation Type</p>
                <p className="m-0 text-label ">
                  {renderAppointmentType(appointmentData?.appointment_type)}
                </p>
                <p className="m-0 consultation-label">
                  {renderConsultationType(
                    appointmentData.appointment_type,
                    appointmentData.consultation_type,
                    appointmentData.procedure_name,
                    appointmentData?.all_procedure_name,
                    appointmentData?.appointment_id,
                    appointmentData?.appointment_status,
                    appointmentData?.payment_method
                  )}
                </p>{" "}
              </div>
            </div>
            <div className="row mt-3 border-top">
              <div className="col-12 d-flex flex-row justify-content-around overflow-auto action-buttons overflowHidden">
                <div
                  id={`demo-${appointmentData.appointment_id}`}
                  class="carousel slide"
                  data-ride="carousel"
                  data-interval="false"
                >
                  <div class="carousel-inner">
                    <div
                      className={`carousel-item justify-content-center active ${
                        mob_options?.slice(0, 3)?.length === 3
                          ? ""
                          : "flex-around"
                      } `}
                    >
                      {mob_options?.slice(0, 3).map((option, index) => (
                        <>
                          {option.label === "Make Call" &&
                          localStorage.getItem("user_type") === "staff" ? (
                            <button
                              key={index}
                              type="button"
                              className={`btn btn-default ${
                                localStorage.getItem("user_type") === "staff"
                                  ? "disabled"
                                  : " "
                              }`}
                              data-tooltip={option.label}
                              data-tooltip-conf="bottom"
                              onClick={
                                localStorage.getItem("user_type") != "staff"
                                  ? option.clickHandler
                                  : " "
                              }
                            >
                              {option.label === "Make Call" && (
                                <>
                                  <img src={option.icon} />
                                  <br />
                                  <small>{option.label}</small>
                                </>
                              )}
                            </button>
                          ) : (
                            <button
                              key={index}
                              type="button"
                              className="btn btn-default"
                              data-tooltip={option.label}
                              data-tooltip-conf="bottom"
                              onClick={option.clickHandler}
                            >
                              {option.label === "View Prescription" && (
                                <Link
                                  to={{
                                    pathname:
                                      "/doctor/account/appointmenthistory/prescription/" +
                                      appointmentData.appointment_id,
                                  }}
                                >
                                  <img src={option.icon} />
                                </Link>
                              )}
                              {option.label !== "View Prescription" && (
                                <img src={option.icon}></img>
                              )}
                              <br />
                              <small>{option.label}</small>
                              {option.label === "Edit Prescription" ? (
                                <small
                                  className="cursor-pointer textLink text-center"
                                  style={{
                                    color: "#DA1346",
                                    fontSize: 10,
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  Expires in {timerHours}:
                                  {timerMinutes < 10
                                    ? `0${timerMinutes}`
                                    : timerMinutes}
                                  :
                                  {timerSeconds < 10
                                    ? `0${timerSeconds}`
                                    : timerSeconds}
                                </small>
                              ) : null}
                            </button>
                          )}
                          {mob_options?.length < 3
                            ? editReceipt(appointmentData, "mobile")
                            : null}
                        </>
                      ))}
                    </div>
                    <div class="carousel-item">
                      {mob_options?.length > 3 &&
                        mob_options?.slice(3).map((option, index) => (
                          <button
                            key={index}
                            type="button"
                            className="btn btn-default"
                            data-tooltip={option.label}
                            data-tooltip-conf="bottom"
                            onClick={option.clickHandler}
                          >
                            {option.label === "View Prescription" && (
                              <Link
                                to={{
                                  pathname:
                                    "/doctor/account/appointmenthistory/prescription/" +
                                    appointmentData.appointment_id,
                                }}
                              >
                                <img src={option.icon} />
                              </Link>
                            )}
                            {option.label !== "View Prescription" && (
                              <img src={option.icon}></img>
                            )}
                            <br />
                            <small>{option.label}</small>
                            {
                              // is_staff === "doctor" &&
                              option.label === "Edit Prescription" ? (
                                <small
                                  className="cursor-pointer textLink text-center"
                                  style={{
                                    color: "#DA1346",
                                    fontSize: 10,
                                    alignItems: "center",
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  Expires in
                                  <span>
                                    {timerHours}:
                                    {timerMinutes < 10
                                      ? `0${timerMinutes}`
                                      : timerMinutes}
                                    :
                                    {timerSeconds < 10
                                      ? `0${timerSeconds}`
                                      : timerSeconds}
                                  </span>
                                </small>
                              ) : null
                            }
                          </button>
                        ))}
                      {mob_options?.length > 3
                        ? editReceipt(appointmentData, "mobile")
                        : null}
                    </div>
                  </div>
                  {showPreviousNext && (
                    <a
                      onClick={() => setShowPreviousNext(false)}
                      class="carousel-control-prev"
                      href={`#demo-${appointmentData.appointment_id}`}
                      data-slide="prev"
                    >
                      <span class="carousel-control-prev-icon"></span>
                      <span>
                        <i class="fa fa-angle-left fa-2x"></i>
                      </span>
                    </a>
                  )}
                  {mob_options?.length > 3 && !showPreviousNext && (
                    <a
                      onClick={() => setShowPreviousNext(true)}
                      class="carousel-control-next"
                      role="button"
                      data-slide="next"
                      href={`#demo-${appointmentData.appointment_id}`}
                    >
                      <span
                        class="carousel-control-next-icon"
                        aria-hidden="true"
                      ></span>
                      <span>
                        <i class="fa fa-angle-right fa-2x"></i>
                      </span>
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
        <ShareReceiptModal show={showReceiptModal} />
        <Popup
          title={"Patient Education Content Shared!"}
          show={showPopUp}
          handleClose={() => setShowPopUp(false)}
        />
        <div className="Message-Modal">
          {showMessage && (
            <Modal show={showMessage} centered>
              <Modal.Body>
                <div className="text-center p-3">
                  <h3 style={{ fontSize: "25px", fontWeight: "500" }}>
                    {message}!
                  </h3>
                </div>
              </Modal.Body>
            </Modal>
          )}
        </div>
        {renderDocument("98%")}
      </div>
    </>
  );
}
